import React, { useEffect, useState, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Button,
} from "@material-ui/core";
import { dataProvider, getChatLog, saveChatLog } from "../utils/util";
import { useChat } from "../context/ChatContext";
import { Send } from "@material-ui/icons";
import "../assets/style.css";
import io from "socket.io-client";
import { useSocketContext } from '../App'
import Register from "./Register";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: "36ch",
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: "inline",
  },
}));


function Chat(props) {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [msg, setMsg] = useState('');
  const [chatList, setChatList] = useState([]);
  // const [connection, setConnection] = useState(false);
  const [socket, setSocket] = useState();
  const chatConfig = useChat();
  // const socketContext = useSocketContext();
  const chatWindowRef = React.useRef();

  const [username, setusername] = useState('');
  const [roomname, setroomname] = useState("collab");
  // const [roomname, setroomname] = useState(Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));

  const [isReg, setReg] = useState(false)

  // useEffect(()=>{
  //   console.log(chatList, "chatlist");
  //   saveChatLog({room:roomname, chat: chatList});
  // },[chatList])

  useEffect(()=>{
   
  },[])

  const scrollToBottom = () => {
    chatWindowRef.current.scrollTop = chatWindowRef.current?.scrollHeight;
  }

  function registrationStatus(data) {
    if(data.registered) {
      setusername(data.value[0])
      setReg(data.registered)
      console.log(data.value[0], 'uname')

      console.log(chatList, "chatlist");
      // let roomRand = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      console.log(getChatLog({room:roomname}), "chatlist");
     
      jRoom(data.value[0]);
    }

  }

 
  useEffect(() => {
    console.log(chatConfig.channel);
    // loadData(chatConfig.channel);
  }, [chatConfig]);

  const jRoom = (uname) => {
    const s = io('https://chat.digipoint.biz', {
      transports: ["websocket", "polling"], // use WebSocket first, if available
      auth: {
        token: 'pj'
      }
    });


    // GOOD
    s.on("connect", async() => {
      console.log("Socket Connected")
      let log = getChatLog({room:roomname});
      console.log(log)
      // setChatList(getChatLog({room:roomname}));
      // jRoom();
    });
    
    s.on("disconnect", () => {
      console.log("Socket Disconnected")
      
      // socket?.emit("chat", { text: uname+" has left the chat" });
      // jRoom();
    });
    console.log({ username: uname, roomname: roomname });
    // setChatList(getChatLog({room:roomname}));

    s.emit("joinRoom", { username: uname, roomname: roomname });
    s.on("message", (args) => {
      console.log(args)
      // setChatList([...chatList, { user: args.username, msg: args.text.text }])
      setChatList(chatList => [...chatList, { user: args.username, msg: args.text }]);
      
      scrollToBottom();
    });
    setSocket(s);

  }


  const handleMessage = (e) => {
    if (e.target.value === '\n') return;
    setMsg(e.target.value)
  }
  const sendMessage = () => {
    // if(!connection) return;
    socket?.emit("chat", { text: msg });

    // saveChatLog({room:roomname, chat: chatList});
    // setChatList([...chatList, {user:'me', msg:msg}])
    setMsg('');
  }
  const enterKeySendMessage = (e) => {
    // console.log(e.key, "key")
    // console.log(e.keyCode , "key-code")
    // console.log(e.shiftKey , "key-code")
    // return;
    if (e.key !== 'Enter' || msg.trim().length < 1 || e.shiftKey) return;
    sendMessage();
  }

  return isReg === false?(  <Register reg={registrationStatus} />):(
    <div style={{ width: 'auto' }}>
      <Grid container>
        <Grid item xs={12}>       
          <div ref={chatWindowRef} style={{ height: 'calc(100vh - 115px)', overflowY: "scroll", maxWidth: '100vw' }} className="imessage">
            {chatList?.map((i, c) => {
              return (
                <>
                 <p key={c} className={i.user === username ? "from-me" : "from-them  margin-b_one"}>
                 <small style={{background:'white', color:'#333', padding:'1px 3px', fontWeight:'bold', borderRadius:5}}>{i.user}</small><br/>
                  {i.msg}
                </p>                
                </>               
                // <p key={c+'key'} className={c % 2 === 0 ? "from-me" : "from-them  margin-b_one"}>
                //   {i.body.substring(0, 10)}
                // </p>
              );
            })}
          </div>

        </Grid>
        <Grid item xs={12} style={{ display: 'flex', maxWidth: '100vw' }}>
          <textarea onChange={handleMessage} onKeyPress={enterKeySendMessage} value={msg} style={{ width: "100%", height: 50, fontSize: '1.1em', marginTop: '10', flex: 50, border:"1px solid #555" }} rows={'3'}></textarea><Button onClick={sendMessage} variant="contained" style={{ flex: 1 }}><Send style={{ color: '#0080ff' }} /></Button>
        </Grid>
      </Grid>
    </div>
  );
}

export default Chat;
